import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkExpando } from './uitk-expando.esm.js';

var UitkExpandoLink = function (props) {
    var _a = props.triggerPosition, triggerPosition = _a === void 0 ? 'trailing' : _a, collapsedLabel = props.expandoTitle, _b = props.expandedLabel, expandedLabel = _b === void 0 ? collapsedLabel : _b, isVisible = props.isVisible, otherProps = __rest(props, ["triggerPosition", "expandoTitle", "expandedLabel", "isVisible"]);
    return (React.createElement(UitkExpando, __assign({}, otherProps, { isVisible: isVisible, expandoTitle: isVisible ? expandedLabel : collapsedLabel, triggerPosition: triggerPosition, type: "link" })));
};
UitkExpandoLink.displayName = 'UitkExpandoLink';

export { UitkExpandoLink };
